import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Output, QueryList, SimpleChange, SimpleChanges, ViewChildren, input, model } from '@angular/core';

@Component({
  selector: 'ev-arrow-choice',
  imports: [NgClass],
  templateUrl: './ev-arrow-choice.component.html',
  styleUrl: './ev-arrow-choice.component.scss'
})
export class EvArrowChoiceComponent {
    readonly options = input<Array<string>>();
    readonly width = input<number>();
    readonly theme = input<string>('grey');
    readonly selected = model<number>(0);

    readonly padding = input<number>(20);
    readonly textDirection = input<string>("right");

    @Output() change: EventEmitter<number> = new EventEmitter<number>();

    @ViewChildren("itemtext") itemtextspans: QueryList<ElementRef>

    transformRight: string = "";
    transition: string = "none";
    itemPadding: string;
    destroyed: boolean;

    
    constructor(private cd: ChangeDetectorRef) { }

    ngOnInit() {
        this.transition = "none";
    }

    ngOnDestroy() {
        this.destroyed = true;
        this.cd.detach();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.calculateArrowOffset(this.selected());
            this.transition = "all 160ms ease-out";
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.someInputsChanged([changes['padding'], changes['textDirection']])) {
            this.setItemPadding();
        }
        else if (this.someInputsChanged([changes['width'], changes['options']])) {
            setTimeout(() => {
                this.calculateArrowOffset(this.selected());
            });
        }
        else if (this.inputChanged(changes['selected'])) {
            this.calculateArrowOffset(this.selected());
        }
    }

    selectOption(idx: number) {
        this.selected.set(idx);
        this.calculateArrowOffset(idx);
        this.change.emit(idx);
    }

    setItemPadding() {
        if (this.destroyed) return

        const textDirection = this.textDirection();
        switch(textDirection) {
            case "right":
                this.itemPadding = `0px 0px 0px ${this.padding()}px`;
                break;
            case "left":
                this.itemPadding = `0px ${this.padding()}px 0px 0px`;
                break;
            case "center":
                this.itemPadding = `0px ${this.padding()/2}px 0px ${this.padding()/2}px`;
                break;
            default:
                throw new Error(`Unsupported text direction '${textDirection}'`);
        }

        this.calculateArrowOffset(this.selected());
    }

    calculateArrowOffset(idx: number) {
        if (this.options()?.length > 0 && !this.destroyed) {
            let offset = 0

            try {
                var spans = this.itemtextspans.toArray().map((ref) => ref.nativeElement)
                if (spans.length === 0)
                    return
            }
            catch(ex) {
                return
            }

            for (let i = 0; i < idx+1; i++) {
                const textDirection = this.textDirection();
                if (textDirection === "left" && i !== 0)
                    offset += this.padding()
                else if (textDirection === "center" && i === 0)
                    offset += this.padding()/2
                else if (textDirection === "center" && i > 0)
                    offset += this.padding()
                else if (textDirection === "right")
                    offset += this.padding()
                if (i < idx)
                    offset += spans[i]?.clientWidth
                else
                    offset += spans[i]?.clientWidth/2
            }

            this.transformRight = 'translateX(' + offset + 'px)';

            this.cd.detectChanges();
        }
    }

    private inputChanged = (change: SimpleChange): boolean => (typeof change !== "undefined" && change !== null && change.previousValue !== change.currentValue)
    /**
     * Returns true if any of the inputs have changed value (only one needs to have changed)
     */
    private someInputsChanged = (changes: SimpleChange[]):boolean => (changes.findIndex((change) => this.inputChanged(change)) > -1)
}